import React, { useState, useEffect } from 'react';
//components
import Rooms from '../components/Rooms';
import HeroSlider from '../components/HeroSlider';
import Testimonials from '../components/Testimonials';
import { SpinnerDotted } from 'spinners-react';
import HomePageLayout from '../components/HomePageLayout';
// import ReserveForm from '../components/ReserveForm';

// import { Helmet } from 'react-helmet';

const Home = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time on initial page load
    setTimeout(() => {
      setLoading(false);
    }, 3000); // Adjust the timeout duration as needed
  }, []);

  return (
    <>
      {/* <Helmet>
        <title>Moja početna stranica</title>
      </Helmet> */}
    {loading && (
        <div className='h-screen fixed bottom-0 top-0 bg-black/90 w-full z-50 flex justify-center items-center'>
          <SpinnerDotted color='white' />
        </div>
      )}
    <HeroSlider />
    <div className='container mx-auto relative'>
    
      {/* <div className='bg-accent/20 mt-4 p-4 lg:shadow-lg lg:absolute
      lg:left-0 lg:right-0 lg:p-0 lg:z-30 lg:-top-12'>
      <BookForm />
      </div> */}
    </div>
    <Rooms />
    <Testimonials />
    {/* <ReserveForm apartmentId='0' /> */}
    {/* <div className='max-w-md mx-auto'>
          <ReserveForm apartmentId='0' />
    </div> */}
    <HomePageLayout />
    </>
  );
};

export default Home;
